import React from "react";

export const isModifiedClick = (e: React.MouseEvent) =>
  e.ctrlKey || e.metaKey || e.shiftKey || e.altKey;
